import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/images/TrainTimelineDeskX4.png'
import _imports_1 from '@/images/TrainTimelineMobX4.png'


const _hoisted_1 = { class: "train-timeline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: _imports_0,
      alt: "Train Timeline",
      class: "timeline-image desktop"
    }, null, -1),
    _createElementVNode("img", {
      src: _imports_1,
      alt: "Train Timeline",
      class: "timeline-image mobile"
    }, null, -1)
  ])))
}